@if (data.label) {
  <h4 class="form-input-list-label">{{ data.label }}</h4>
}
@if (data.description) {
  <p>{{ data.description }}</p>
}

<div class="form-input-list-rows">
  <div class="form-input-list-row form-input-list-header">
    <div class="form-input-list-fields">
      @for (item of data.items; track item.name) {
        <div class="form-input-list-field-header">{{ item.label || item.name }}</div>
      }
    </div>
    <div class="form-input-list-actions"></div>
  </div>

  @for (inputRow of inputRows; track $index; let rowIndex = $index) {
    <div class="form-input-list-row" [@rowAnimation]>
      <div class="form-input-list-fields">
        <ng-container
          [groupControl]="getGroupControl(rowIndex)"
          [groupItem]="inputRow"
          uiFormDynamicElements
        ></ng-container>
      </div>
      <div class="form-input-list-actions">
        <ui-icon-button
          (clicked)="addRow(rowIndex)"
          buttonStyle="unthemed"
          icon="plus"
          iconStyle="light"
          class="action-button"
        ></ui-icon-button>
        <ui-icon-button
          (clicked)="removeRow(rowIndex)"
          [disabled]="inputRows.length === 1"
          buttonStyle="unthemed"
          icon="minus"
          iconStyle="light"
          class="action-button"
        ></ui-icon-button>
      </div>
    </div>
  }
</div>
